export default __webpack_public_path__ + "static/media/alert-icon.7f5efd65.svg";